import { FaApple, FaLinux, FaWindows } from 'react-icons/fa';
import { useMemo } from 'react';
import { getEnvByName, handleCopyToClipboard } from 'src/utils';
import StoreDownloads from 'src/components/StoreDownloads';
import { getDevicePlatform } from 'src/utils/devicePlatform';

const downloadLinux = getEnvByName('VITE_DOWNLOAD_LINUX_LINK') ?? '';
const downloadWindows = getEnvByName('VITE_DOWNLOAD_WINDOWS_LINK') ?? '';
const downloadMacOS = getEnvByName('VITE_DOWNLOAD_MACOS_LINK') ?? '';
const webViewLink = getEnvByName('VITE_WEB_VIEW_LINK') ?? 'https://web.werxpace.click';

const linuxCommand = 'sudo apt install <path to file>';

const Downloads = (): JSX.Element => {
  const platform = useMemo(getDevicePlatform, []);
  const isMobile = platform === 'android' || platform === 'ios';

  return (
  <section id="downloads-section" aria-labelledby="downloads-heading">
    <h2 id="downloads-heading" className="rv">
      Choose your <span className="c">platform</span>
    </h2>
    {isMobile ? <StoreDownloads platform={platform} /> : null}
    <ul className="cards">
      <li className="rv" style={{ ['--d' as string]: 0 }}>
        <div className="card" data-recommended={platform === 'linux'}>
          <FaLinux className="big" aria-hidden="true" />
          <h3>Linux</h3>
          <span className="download-recommendation" aria-hidden={platform !== 'linux'}> {platform === 'linux' ? 'Recommended for your device' : '\u00a0'} </span>
          <a className="btn download-link" href={downloadLinux} download={true}>
            Download
          </a>
          <p className="download-note installation-help">
            Open Terminal and run:<br />
            <button className="copy-command" type="button" title="Copy installation command" aria-label={`Copy command: ${linuxCommand}`} onClick={() => {return handleCopyToClipboard(linuxCommand)}}>
              <code>{linuxCommand}</code>
            </button>
          </p>
        </div>
      </li>
      <li className="rv" style={{ ['--d' as string]: 1 }}>
        <div className="card" data-recommended={platform === 'windows'}>
          <FaWindows className="big" aria-hidden="true" />
          <h3>Windows</h3>
          <span className="download-recommendation" aria-hidden={platform !== 'windows'}> {platform === 'windows' ? 'Recommended for your device' : '\u00a0'} </span>
          <a className="btn download-link" href={downloadWindows} download={true}>
            Download
          </a>
          <p className="download-note">Download the installer and run it to get started.</p>
        </div>
      </li>
      <li className="rv" style={{ ['--d' as string]: 2 }}>
        <div className="card" data-recommended={platform === 'mac'}>
          <FaApple className="big" aria-hidden="true" />
          <h3>Mac</h3>
          <span className="download-recommendation" aria-hidden={platform !== 'mac'}> {platform === 'mac' ? 'Recommended for your device' : '\u00a0'} </span>
          <a className="btn download-link" href={downloadMacOS} download={true}>
            Download
          </a>
          <p className="download-note">Download the app and open it to get started.</p>
        </div>
      </li>
    </ul>
    <div className="rv" style={{ ['--d' as string]: 3 }}>
      <div className="or">
        <a className="lnk" href={webViewLink} target="_blank" rel="noopener noreferrer">
          Or open WerxPace in your browser <span className="ar" aria-hidden="true">→</span>
        </a>
      </div>
    </div>
    {!isMobile && <StoreDownloads platform={platform} />}
  </section>
  );
};

export default Downloads;
